var LoginValidate = $.extend({/* LoginValidate */}, BaseComponent, {

	componentSelector: '#login-data',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {

		$(element).validate({
			rules: {
				nif: {
				  required: true,
				  nifES: true
				},
				password: {
					required: true,
					minlength: 10,
					maxlength: 24
				}
			},
			submitHandler: function(form) {
				form.submit();
			},
            errorPlacement: function (error, element) {
                if (element.attr("type") == "checkbox") {
                    error.insertAfter((element).next('label'));
                } else {
                    error.insertAfter(element);
                }
            }
		});

		$(element).find('#login-submit').click((function(event) {

			$(element).submit();

		}).bind(this));

	}

})